angular.module("alk.constants")
  /** @name STATES
   * @ngdoc constant
   * @description Provides a list of states that are supported by ALK applications.
   * The constant is an array of objects that look like
   * `{abbreviation: string, name: string, country: string}`
   * @memberof alk.constants
   */
  .constant("STATES", [{
      "abbreviation": "AL",
      "name": "Alabama",
      "country": "United States"
    },
    {
      "abbreviation": "AK",
      "name": "Alaska",
      "country": "United States"
    },
    {
      "abbreviation": "AZ",
      "name": "Arizona",
      "country": "United States"
    },
    {
      "abbreviation": "AR",
      "name": "Arkansas",
      "country": "United States"
    },
    {
      "abbreviation": "CA",
      "name": "California",
      "country": "United States"
    },
    {
      "abbreviation": "CO",
      "name": "Colorado",
      "country": "United States"
    },
    {
      "abbreviation": "CT",
      "name": "Connecticut",
      "country": "United States"
    },
    {
      "abbreviation": "DE",
      "name": "Delaware",
      "country": "United States"
    },
    {
      "abbreviation": "DC",
      "name": "District of Columbia",
      "country": "United States"
    },
    {
      "abbreviation": "FL",
      "name": "Florida",
      "country": "United States"
    },
    {
      "abbreviation": "GA",
      "name": "Georgia",
      "country": "United States"
    },
    {
      "abbreviation": "HI",
      "name": "Hawaii",
      "country": "United States"
    },
    {
      "abbreviation": "ID",
      "name": "Idaho",
      "country": "United States"
    },
    {
      "abbreviation": "IL",
      "name": "Illinois",
      "country": "United States"
    },
    {
      "abbreviation": "IN",
      "name": "Indiana",
      "country": "United States"
    },
    {
      "abbreviation": "IA",
      "name": "Iowa",
      "country": "United States"
    },
    {
      "abbreviation": "KS",
      "name": "Kansas",
      "country": "United States"
    },
    {
      "abbreviation": "KY",
      "name": "Kentucky",
      "country": "United States"
    },
    {
      "abbreviation": "LA",
      "name": "Louisiana",
      "country": "United States"
    },
    {
      "abbreviation": "ME",
      "name": "Maine",
      "country": "United States"
    },
    {
      "abbreviation": "MD",
      "name": "Maryland",
      "country": "United States"
    },
    {
      "abbreviation": "MA",
      "name": "Massachusetts",
      "country": "United States"
    },
    {
      "abbreviation": "MI",
      "name": "Michigan",
      "country": "United States"
    },
    {
      "abbreviation": "MN",
      "name": "Minnesota",
      "country": "United States"
    },
    {
      "abbreviation": "MS",
      "name": "Mississippi",
      "country": "United States"
    },
    {
      "abbreviation": "MO",
      "name": "Missouri",
      "country": "United States"
    },
    {
      "abbreviation": "MT",
      "name": "Montana",
      "country": "United States"
    },
    {
      "abbreviation": "NE",
      "name": "Nebraska",
      "country": "United States"
    },
    {
      "abbreviation": "NV",
      "name": "Nevada",
      "country": "United States"
    },
    {
      "abbreviation": "NH",
      "name": "New Hampshire",
      "country": "United States"
    },
    {
      "abbreviation": "NJ",
      "name": "New Jersey",
      "country": "United States"
    },
    {
      "abbreviation": "NM",
      "name": "New Mexico",
      "country": "United States"
    },
    {
      "abbreviation": "NY",
      "name": "New York",
      "country": "United States"
    },
    {
      "abbreviation": "NC",
      "name": "North Carolina",
      "country": "United States"
    },
    {
      "abbreviation": "ND",
      "name": "North Dakota",
      "country": "United States"
    },
    {
      "abbreviation": "OH",
      "name": "Ohio",
      "country": "United States"
    },
    {
      "abbreviation": "OK",
      "name": "Oklahoma",
      "country": "United States"
    },
    {
      "abbreviation": "OR",
      "name": "Oregon",
      "country": "United States"
    },
    {
      "abbreviation": "PA",
      "name": "Pennsylvania",
      "country": "United States"
    },
    {
      "abbreviation": "RI",
      "name": "Rhode Island",
      "country": "United States"
    },
    {
      "abbreviation": "SC",
      "name": "South Carolina",
      "country": "United States"
    },
    {
      "abbreviation": "SD",
      "name": "South Dakota",
      "country": "United States"
    },
    {
      "abbreviation": "TN",
      "name": "Tennessee",
      "country": "United States"
    },
    {
      "abbreviation": "TX",
      "name": "Texas",
      "country": "United States"
    },
    {
      "abbreviation": "UT",
      "name": "Utah",
      "country": "United States"
    },
    {
      "abbreviation": "VT",
      "name": "Vermont",
      "country": "United States"
    },
    {
      "abbreviation": "VA",
      "name": "Virginia",
      "country": "United States"
    },
    {
      "abbreviation": "WA",
      "name": "Washington",
      "country": "United States"
    },
    {
      "abbreviation": "WV",
      "name": "West Virginia",
      "country": "United States"
    },
    {
      "abbreviation": "WI",
      "name": "Wisconsin",
      "country": "United States"
    },
    {
      "abbreviation": "WY",
      "name": "Wyoming",
      "country": "United States"
    },
    {
      "abbreviation": "AB",
      "name": "Alberta",
      "country": "Canada"
    },
    {
      "abbreviation": "BC",
      "name": "British Columbia",
      "country": "Canada"
    },
    {
      "abbreviation": "MB",
      "name": "Manitoba",
      "country": "Canada"
    },
    {
      "abbreviation": "NB",
      "name": "New Brunswick",
      "country": "Canada"
    },
    {
      "abbreviation": "NF",
      "name": "Newfoundland",
      "country": "Canada"
    },
    {
      "abbreviation": "NT",
      "name": "Northwest Territory",
      "country": "Canada"
    },
    {
      "abbreviation": "NS",
      "name": "Nova Scotia",
      "country": "Canada"
    },
    {
      "abbreviation": "NU",
      "name": "Nunavut",
      "country": "Canada"
    },
    {
      "abbreviation": "ON",
      "name": "Ontario",
      "country": "Canada"
    },
    {
      "abbreviation": "PE",
      "name": "Prince Edward Island",
      "country": "Canada"
    },
    {
      "abbreviation": "QC",
      "name": "Quebec",
      "country": "Canada"
    },
    {
      "abbreviation": "SK",
      "name": "Saskatchewan",
      "country": "Canada"
    },
    {
      "abbreviation": "YT",
      "name": "Yukon Territory",
      "country": "Canada"
    },
    {
      "abbreviation": "AG",
      "name": "Aguascalientes",
      "country": "Mexico"
    },
    {
      "abbreviation": "BJ",
      "name": "Baja California",
      "country": "Mexico"
    },
    {
      "abbreviation": "BS",
      "name": "Baja California Sur",
      "country": "Mexico"
    },
    {
      "abbreviation": "CP",
      "name": "Campeche",
      "country": "Mexico"
    },
    {
      "abbreviation": "CH",
      "name": "Chiapas",
      "country": "Mexico"
    },
    {
      "abbreviation": "CI",
      "name": "Chihuahua",
      "country": "Mexico"
    },
    {
      "abbreviation": "CU",
      "name": "Coahuila",
      "country": "Mexico"
    },
    {
      "abbreviation": "CL",
      "name": "Colima",
      "country": "Mexico"
    },
    {
      "abbreviation": "DF",
      "name": "Distrito Federal",
      "country": "Mexico"
    },
    {
      "abbreviation": "DG",
      "name": "Durango",
      "country": "Mexico"
    },
    {
      "abbreviation": "GJ",
      "name": "Guanajuato",
      "country": "Mexico"
    },
    {
      "abbreviation": "GR",
      "name": "Guerrero",
      "country": "Mexico"
    },
    {
      "abbreviation": "HG",
      "name": "Hidalgo",
      "country": "Mexico"
    },
    {
      "abbreviation": "JA",
      "name": "Jalisco",
      "country": "Mexico"
    },
    {
      "abbreviation": "EM",
      "name": "Mexico",
      "country": "Mexico"
    },
    {
      "abbreviation": "MH",
      "name": "Michoacan",
      "country": "Mexico"
    },
    {
      "abbreviation": "MR",
      "name": "Morelos",
      "country": "Mexico"
    },
    {
      "abbreviation": "NA",
      "name": "Nayarit",
      "country": "Mexico"
    },
    {
      "abbreviation": "NL",
      "name": "Nuevo Leon",
      "country": "Mexico"
    },
    {
      "abbreviation": "OA",
      "name": "Oaxaca",
      "country": "Mexico"
    },
    {
      "abbreviation": "PU",
      "name": "Puebla",
      "country": "Mexico"
    },
    {
      "abbreviation": "QA",
      "name": "Queretaro",
      "country": "Mexico"
    },
    {
      "abbreviation": "QR",
      "name": "Quintana Roo",
      "country": "Mexico"
    },
    {
      "abbreviation": "SL",
      "name": "San Luis Potosi",
      "country": "Mexico"
    },
    {
      "abbreviation": "SI",
      "name": "Sinaloa",
      "country": "Mexico"
    },
    {
      "abbreviation": "SO",
      "name": "Sonora",
      "country": "Mexico"
    },
    {
      "abbreviation": "TA",
      "name": "Tabasco",
      "country": "Mexico"
    },
    {
      "abbreviation": "TM",
      "name": "Tamaulipas",
      "country": "Mexico"
    },
    {
      "abbreviation": "TL",
      "name": "Tlaxcala",
      "country": "Mexico"
    },
    {
      "abbreviation": "VZ",
      "name": "Veracruz",
      "country": "Mexico"
    },
    {
      "abbreviation": "YC",
      "name": "Yucatan",
      "country": "Mexico"
    },
    {
      "abbreviation": "ZT",
      "name": "Zacatecas",
      "country": "Mexico"
    }
  ]);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/states.js